// ─── src/api/reportLeads.ts ───────────────────────────────────────────────────

import { apiClient } from "./registration";
import type { ReportLeadParams, ReportLeadResponse, ReportLeadStats } from "../types/reportLead";
import type { PaginationMeta } from "../types/registration";

export interface NormalisedReportLeadResponse {
  data: import("../types/reportLead").ReportLead[];
  meta: PaginationMeta;
}

const normalise = (raw: ReportLeadResponse): NormalisedReportLeadResponse => ({
  data: raw.data,
  meta: {
    total:      raw.total,
    page:       raw.page,
    limit:      raw.limit,
    totalPages: Math.ceil(raw.total / raw.limit),
  },
});

export const getReportLeads = async (
  params: ReportLeadParams,
): Promise<NormalisedReportLeadResponse> => {
  const cleanParams = Object.fromEntries(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== "" && v !== null),
  );
  const { data } = await apiClient.get<ReportLeadResponse>("/report-leads", {
    params: cleanParams,
  });
  return normalise(data);
};

export const getReportLeadStats = async (): Promise<ReportLeadStats> => {
  const { data } = await apiClient.get<ReportLeadStats>("/report-leads/stats");
  return data;
};

export const deleteReportLead = async (id: string): Promise<void> => {
  await apiClient.delete(`/report-leads/${id}`);
};
